import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import './App.css';
import Zodvia from './pages/Zodvia';
import EASI from "./pages/EASI";


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            path="/zodvia/politica" 
            element={<Zodvia/>}
          />
          <Route
            path="/zodvia/EASI" 
            element={<EASI/>}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
